import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
} from '@angular/core';

@Component({
  selector: 'app-custom-rate',
  templateUrl: './custom-rate.component.html',
  styleUrls: ['./custom-rate.component.scss'],
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomRateComponent {
  openExternalScreen() {
    const url = `${window.location.origin}/slt/apps/external-web/#/create-rate-request`;
    window.open(url, '_blank', 'noopener,noreferrer');
  }
}
